import { Component, OnInit, Input } from '@angular/core';
import { PtlWindowLocationService } from '@ptl/global-components';
//import * as moment from 'moment';
import moment from 'moment';

@Component({
  selector: 'app-media-card',
  templateUrl: './media-card.component.html',
  styleUrls: ['./media-card.component.scss'],
  standalone: false
})
export class MediaCardComponent implements OnInit {
  @Input() thumbnail;
  @Input() title: string;
  @Input() description: string;
  @Input() link: string;
  @Input() tags: [];
  @Input() publishDate: Date;
  @Input() altText: string;

  formattedDate: string;
  imageUrl: string;

  constructor(
    private windowLocationService: PtlWindowLocationService
  ){}

  ngOnInit(): void {
    console.log(this.tags);
    this.formattedDate = moment.utc(this.publishDate).format('MMMM D, YYYY');
  }

  goToMediaLink(): void {
    this.windowLocationService.goToUrl(this.link, { newTab: true });
  }
}
